/**
 * Base search DTO
 */
export abstract class BaseSearchDto {
  id!: number;
  color?: string | null;
  createdAt?: Date;
  createdByUserId?: number | null;
  createdByUsername?: string | null;
  updatedAt?: Date | null;
  updatedByUserId?: number | null;
  updatedByUsername?: string | null;
}
